import { render } from "./OkurijoJissekiPage.vue?vue&type=template&id=056881ec"
import script from "./OkurijoJissekiPage.vue?vue&type=script&lang=js"
export * from "./OkurijoJissekiPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__